module.exports = __webpack_public_path__ + "img/icone-coa-alert.5486677b.svg";